import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=2ef64e08&scoped=true"
import script from "./Achievements.vue?vue&type=script&lang=ts"
export * from "./Achievements.vue?vue&type=script&lang=ts"
import style0 from "./Achievements.vue?vue&type=style&index=0&id=2ef64e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef64e08",
  null
  
)

export default component.exports